// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'

const pl = {
  paddingLeft: '3px',
}

const FormatPowerHeader = () => (
  <div
    className={'display-flex flex-direction-row flex-wrap-nowrap justify-content-end'}
    title={'Highest power of all modulations'}>
    <span>{'Pwr'}</span>
    <small style={pl}>{'(dBm)'}</small>
  </div>
)

export default FormatPowerHeader
